import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';


import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import ShowProformaInvoice from "components/product/components/price-calculation/ShowProformaInvoice";
import FieldView2 from "core/components/layout/FieldView2";
import CommentMgmt from "../comment/CommentMgmt";
import {setProductUpdateproductModal,setSelectedProductId} from "store/slice/PharmaSlice";
import UpdateproductActionModal from "components/product/action/updateproduct/UpdateproductActionModal";

export default function TaskSpaceAccounts() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const { commentList } = useSelector(state => state.appslice.wkflow);
  const [localProductList, setLocalProductList] = useState([]);
  const {pharmaorderObj} = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const {productList} = useSelector((state) => state.pharmaslice);

  useEffect(() => {
    dispatch(setCompleteTaskButtonEnabled(true));
    setLocalProductList(productList.filter(product => product.orderid === pharmaorderObj.id && (
      product.statusname!=='CANCELLED' && product.overallstatusid!==10)));
  }, []);
  useEffect(() => {
   if (commentList && commentList.length > 0) {
      dispatch(setReferbackTaskButtonEnabled(true));
    }
  }, [commentList]);

  const editProduct = (product) => {
      //dispatch(setSelectedProductId(product.id));
      dispatch(setProductUpdateproductModal(true));
    };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
          <Grid container sx={{ width: '100%' }}>
            <Grid item lg={8} md={4} sm={4} xs={12}>
              <ShowProformaInvoice  />
            </Grid>
            <Grid item lg={4} md={8} sm={8} xs={12} sx={{ pl: 2 }}>
              <Grid container sx={{ width: '100%', }}>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{  borderRadius: 2,mb:2}}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>Product(s)</Typography>
                  <Grid container direction="row" sx={{ width: '100%', }}>
                    {localProductList.map((product, index) => (
                      <Grid item lg={6} md={12} sm={12} xs={12} key={index} sx={{display:productObj.id !== product.id?'none':'block', mb: 2, pr: 1 }}>
                        <Box sx={{  backgroundColor: productObj.id===product.id?'primary.darker':'white', color:productObj.id===product.id?'white':'', borderRadius: 2,p:1, cursor:'pointer' }} onClick={() => dispatch(setSelectedProductId(product.id))}>
                          <Typography variant="h5" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {product.brandname}
                            
                          </Typography> 
                          <Typography variant="h6" color="primary">{product.title}</Typography> 
                        </Box>
                      </Grid>
                    ))}
                   
                  </Grid>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{  borderRadius: 2,}}>
                  <Box sx={{width:'100%', backgroundColor: "white", borderRadius: 2, p: 1 }}>
                    <CommentMgmt maxHeight='50vh'/>
                  </Box>                 
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <UpdateproductActionModal/>
        </Grid>
          
    
  );
}